import type { StudioCatalog, StudioDeck, StudioDefinition } from 'src/components/star-grid/reportStudio.types';
import { studioScenario, studioVariance } from 'src/components/star-grid/utils/studioDraft';

export const addStudioScenario = (
  deck: StudioDeck,
  catalog: StudioCatalog,
  definition: StudioDefinition,
  scenarioId?: string,
  baseId?: string
): StudioDeck => {
  const scenario = studioScenario(catalog, definition, scenarioId);
  const baseIndex = deck.columns.findIndex((column) => column.id === baseId && column.kind === 'scenario');
  const base = deck.columns[baseIndex];
  if (!baseId || base?.kind !== 'scenario') return { ...deck, columns: [...deck.columns, scenario] };
  const compare = { ...scenario, period_ids: [...base.period_ids], currency_ids: [...base.currency_ids], metric_id: base.metric_id };
  const variance = { ...studioVariance([base, compare], base.id), compare_block_id: compare.id };
  return { ...deck, columns: [...deck.columns.slice(0, baseIndex + 1), compare, variance, ...deck.columns.slice(baseIndex + 1)] };
};
